import { usePageInfo } from "@/contexts/PageInfoProvider";
import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";
import { ImageUploader } from "components/common/Uploader/ImageUploader/ImageUploader";
import { useRouter } from "next/router";
import { MAX_UPLOAD_LIMIT } from "../uploaderUtils";
import { useConverterUploader } from "./useConverterUploader";
import { getAnalytics, getHtmlFileInputId } from "./utils";
import { useFormatInfos } from "@/modules/ImageConverter/hooks/useFormatInfos";
import { useDailyQuota } from "@/modules/DailyQuota/hooks/useDailyQuota";

const ConverterUploaderContent = () => {
    const { deleteImage, deleteAllImages } = useConverterUploader();
    const { asPath } = useRouter();
    const { sources } = usePageInfo();
    useFormatInfos();
    const quotaManager = useDailyQuota();

    return (
        <ImageUploader
            deleteImage={deleteImage}
            deleteAllImages={deleteAllImages}
            maxUploads={MAX_UPLOAD_LIMIT}
            analytics={getAnalytics(asPath)}
            htmlFileInputId={getHtmlFileInputId(asPath)}
            supportedExtensions={sources}
            ignoreExtensionCheck={["google-drive"]}
            quotaManager={quotaManager}
        />
    );
};

export const ImageConverterUploader = () => {
    return (
        <ReduxProvider>
            <ConverterUploaderContent />
        </ReduxProvider>
    );
};
